// Newman Construction's own contact details, as printed on customer-facing
// documents. One source for every renderer: the invoice/estimate letterhead and
// footer (backend document shell) and the inspection report cover sheet (which
// is rendered twice — by the editor preview and by the PDF generator).
export const NEWMAN_COMPANY = {
  name: 'Newman General Construction',
  address: '1527 38th Ave, San Francisco, CA 94122',
  phone: '(415) 665-9111',
  email: 'NewmanGeneralConstruction@Gmail.com',
  license: 'Lic #986605 (Class B and Class C33)',
} as const;
